import { useEffect } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import RALayout from "../components/ra/RALayout";
import redirects from "../seo/redirects.json";

// Old WordPress links land here: send them to their new page, otherwise show a friendly 404.
export default function NotFound() {
  const { pathname, search } = useLocation();
  const target = redirects[pathname.replace(/\/+$/, "") || "/"];
  useEffect(() => {
    if (target) return undefined;
    const m = Object.assign(document.createElement("meta"), { name: "robots", content: "noindex" });
    document.head.appendChild(m);
    return () => m.remove();
  }, [target]);
  if (target) return <Navigate to={target + (target.includes("?") ? "" : search)} replace />;
  return (
    <RALayout>
      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-24" data-testid="not-found">
        <p className="font-mono text-xs tracking-[0.25em] uppercase text-moss mb-4">Page not found</p>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tight">This trail doesn't go anywhere</h1>
        <p className="mt-4 text-ink-secondary">The page may have moved when we rebuilt our website.</p>
        <div className="mt-8 flex gap-3">
          <Link to="/tours" className="h-11 px-5 rounded-sm bg-terracotta text-white font-semibold inline-flex items-center" data-testid="not-found-tours">See all tours</Link>
          <Link to="/blog" className="h-11 px-5 rounded-sm border border-sand-dark inline-flex items-center" data-testid="not-found-blog">Read the journal</Link>
        </div>
      </section>
    </RALayout>
  );
}
